export const SEVERITY = {
  critical: { label: "Critical", color: "#EF4444", bg: "rgba(239,68,68,0.12)", border: "rgba(239,68,68,0.35)" },
  high: { label: "High", color: "#F97316", bg: "rgba(249,115,22,0.12)", border: "rgba(249,115,22,0.35)" },
  medium: { label: "Medium", color: "#EAB308", bg: "rgba(234,179,8,0.12)", border: "rgba(234,179,8,0.35)" },
  low: { label: "Low", color: "#10B981", bg: "rgba(16,185,129,0.12)", border: "rgba(16,185,129,0.35)" },
  secure: { label: "Secure", color: "#00E5FF", bg: "rgba(0,229,255,0.10)", border: "rgba(0,229,255,0.30)" },
};

export function scoreColor(score) {
  if (score >= 90) return "#00E5FF";
  if (score >= 75) return "#10B981";
  if (score >= 60) return "#EAB308";
  if (score >= 40) return "#F97316";
  return "#EF4444";
}
